import { FacebookRegularIcon as FacebookIcon, InstagramIcon, RedditIcon } from '@change/ds-icons';

import type { EnrichedReadyToSharePlatformPostV2 } from 'src/app/shared/api/readyToShare';

const PLATFORM_ICONS = {
	facebook: {
		variant: 'facebook' as const,
		icon: FacebookIcon,
	},
	instagram: {
		variant: 'instagram' as const,
		icon: InstagramIcon,
	},
	reddit: {
		variant: 'reddit' as const,
		icon: RedditIcon,
	},
};

export const ICON_VARIANTS: Record<
	EnrichedReadyToSharePlatformPostV2['__typename'],
	(typeof PLATFORM_ICONS)[keyof typeof PLATFORM_ICONS]
> = {
	ReadyToShareFacebookPost: PLATFORM_ICONS.facebook,
	ReadyToShareFacebookStory: PLATFORM_ICONS.facebook,
	ReadyToShareFacebookGroupsPost: PLATFORM_ICONS.facebook,
	ReadyToShareInstagramPost: PLATFORM_ICONS.instagram,
	ReadyToShareInstagramStory: PLATFORM_ICONS.instagram,
	ReadyToShareRedditGroupsPost: PLATFORM_ICONS.reddit,
};
